import ThemeActionTypes from './theme.types';

export const changeThemeToDark = () => ({
  type: ThemeActionTypes.CHANGE_THEME_TO_DARK,
});
export const changeThemeToLight = () => ({
  type: ThemeActionTypes.CHANGE_THEME_TO_LIGHT,
});
